<template>
	<div class="no_data_box">
		<div class="no_data">
			<img src="../../assets/icon/no_data.png" alt="TOZO Community no data icon"/>
			<div class="no_data_text" v-if="login_state">
				{{ no_data_text }}
			</div>
			<div class="login_state_box" v-else>
				{{ no_login_text }}
				<div class="login_state" @click="go_to_login()">
					{{ $t('noDataArr.go_login') }}
					<i class="el-icon-arrow-right"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'NoData',

	props: {
		Loading: {
			type: Boolean,
			default: false,
		},
		calling_modules: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			login_state: false,
			no_login_text: this.$t('noDataArr.interesting_things'),
			no_data_text: ""
		}
	},
	
	// 监听
	watch: {
		"$store.state.userinfo": {
			handler: function (newValue, oldValue) {
				this.if_login()
			},
			deep: true
		},
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		this.if_login()
		this.set_data_text()
	},
  
	methods:{
		// 是否提示登录
		if_login(){
			if(this.calling_modules == "search-user" || this.calling_modules == "comment-module"){
				this.login_state = true
			}else{
				if(!this.$store.state.userinfo.login_token){
					this.login_state = false
				}else{
					this.login_state = true
				}
			}
			this.set_data_text()
		},
		
		//无数据提示
		set_data_text(){
			let text = this.$t('noDataArr.No_data_yet')
			if(this.calling_modules == "follow-list"){
				text = this.$t('noDataArr.follow_list') //关注页面 您还没关注任何人
			}else if(this.calling_modules == "fans-list"){
				text = this.$t('noDataArr.fan_home_page') //粉丝页面
			}else if(this.calling_modules == "message"){
				text = this.$t('noDataArr.message') //消息页面 评论
			}else if(this.calling_modules == "comment-module"){
				text = this.$t('noDataArr.comment_module') //详情页页面 评论
			}else if(this.calling_modules == "likes-module"){
				text = this.$t('noDataArr.likes_module') //消息页面 点赞
			}else if(this.calling_modules == "comment-replies-list"){
				text = this.$t('noDataArr.comment_replies_list') //评论回复页面
			}else if(this.calling_modules == "new-followers"){
				text = this.$t('noDataArr.new_fan_follow_list') //消息页面 新粉丝
			}else if(this.calling_modules == "search-user"){
				text = this.$t('noDataArr.search_user') //搜索，暂无相关推荐
			}
			this.no_data_text = text
		},
		
		//去登录
		go_to_login(){
			this.$router.replace({
				path: '/login',
				query: {
					redirect: this.$router.currentRoute.fullPath
				}
			})
		},
	}
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.no_data_box{
		background-color: #ffffff;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		// color: #999;
		padding: 10px 10px;
		font-size: 14px;
		border-radius: 8px;
		.no_data{
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
		}
		img{
			max-width: 100px;
			width: 100%;
		}
		.no_data_text{
			margin-top: 20px;
			text-align: center;
			max-width: 250px;
		}
	}
	.login_state_box{
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		max-width: 250px;
	}
	.login_state{
		cursor: pointer;
		margin-top: 20px;
		font-size: 16px;
		color: #06f;
		// color: #2094FA;
		list-style: 1;
		display: flex;
		align-items: center;
	}
	
	@media screen and (min-width: 1024px) {
		.no_data_box{
			min-height: 300px;
		}
	}
	@media screen and (max-width: 1024px) {
		.no_data_box{
			/* 50+10+41+147+10 */
			min-height: calc(100vh - 288px);
		}
	}
</style>
